import EventEmitter from "./EventEmitter";

export default class Bubble extends EventEmitter {
  constructor(url, asset_id) {
    super();
    this.bubbleWrapper = document.createElement("div");
    this.bubbleWrapper.className = "bubbleWrapper";
    this.bubbleWrapper.classList.add("hide");
    this.bubbleWrapper.addEventListener("click", (e) => {
      this.onClick(e);
    });
    this.bubbleWrapper.setAttribute("data-assetid", asset_id);
    const img = new Image();
    img.onload = this.loaded.bind(this);
    img.src = `${url}`;
  }
  loaded(e) {
    // console.log(e);
    this.bubbleWrapper.appendChild(e.target);
    this.raiseEvent("loaded", [{ bubble: this.bubbleWrapper }]);
  }
  onClick(e) {
    this.raiseEvent("bubbleclicked", [e.target]);
  }
}
